import React, { useState } from "react";
import { Fieldset, track } from "react-redux-form";
import { Button, Col, Row, Table } from "reactstrap";
import { compose } from "recompose";
import { Trans } from "react-i18next";
import { getStatus, FormGroup, onMount, Page, required, withLocalForm, withReload, } from "components/common";
import { CurrencySymbol, SpanColor, cStyle, formatCurrency, formatDate, formatDate as formatedDate } from "services/util";
import BackButton from "components/refactoring/BackButton";
import { NotificationManager } from "react-notifications";
import { getOutlineStyle } from "pages/UserList/Edit";

export const ViewInvoice = ({
  item,
  LocalForm,
  onSubmit,
  client,
  t,
  selectedOrganisation
}) => {

  const tableStyle = {
    borderCollapse: 'collapse',
    width: '30%',
  };

  const tStyle = {
    border: '1px solid #ddd', 
    padding: '8px',
  };

  const [downloading, setDownloading] = useState()
  const [printing, setPrinting] = useState()


  const handleDownload = async (id, invoice_number) => {

    setDownloading(true)

    try {
      const response = await client.get(`/core/invoice/${id}/download_invoice`, { responseType: 'blob' });
  
      const blob = new Blob([response.data], { type: response.data.type });
  
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      console.log("Blob==", blob)
      link.download = `${invoice_number}.pdf`;
      link.click();
  
      window.URL.revokeObjectURL(link.href);
      NotificationManager.success("Downloaded Successfully!");
      setDownloading(false)

    } catch (error) {
      console.error("Error fetching data:", error);
      NotificationManager.error("Error occured");
      setDownloading(false)
    }
  };

  const handlePrint = async (id, invoice_number) => {
    setPrinting(true);
  
    try {
      const response = await client.get(`/core/invoice/${id}/download_invoice`, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: response.data.type });
  
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank', 'height=500,width=800');
  
      if (!newWindow) {
        NotificationManager.info('Failed to open print window. Please allow pop-ups for this site.');
      }
  
      newWindow.onload = () => {
        newWindow.print();
        window.URL.revokeObjectURL(url);
        setPrinting(false);
      };
  
      NotificationManager.success('Printing Started!');
    } catch (error) {
      console.error('Error fetching data:', error);
      NotificationManager.error('Error occurred while printing');
      setPrinting(false);
    }
  };

  const status_map = {
    'PAID':{'color':'#72B566', text:t('Paid')},
    'UNPAID':{'color':'#ffc107', text:t('Unpaid')},
    'CANCELLED':{'color':'#dc3545', text:t('Cancelled')}
  }

  return (
    <div className="nw-invoiceStyle">
      <Page
        title={
          item.InvoiceID
            ? t(`Invoice {{ InvoiceNumber }}`, {
              InvoiceNumber: item.InvoiceNumber,
            })
            : ''
        }
        translate={false}
      >
        {item && item.LineItems ? <>
          <div className="my-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <BackButton />
            {item?.Status && <span style={getOutlineStyle(status_map[item.Status].color)}>{status_map[item.Status].text}</span>}
          </div>
          <div className="d-flex align-items-center" style={{ paddingBottom: 20 }}>
            {item.SentToXero && (
              <div className="text-success small">
                <span className="fa fa-check mr-1" /> <Trans>Sent to Xero</Trans>
              </div>
            )}
            
            <div className="mx-auto" />
            {item?.Status === "PAIDS" && 
            <>
                <Button color="primary" className="mx-0" disabled={printing} size="sm" onClick={() => handlePrint(item?.ID, item?.InvoiceNumber)}>{!printing ? <i className="fa fa-print mr-1" /> : <i className="fa fa-spin fa-spinner mr-1" />}<Trans>{printing ? "Printing" : "Print Invoice"}</Trans></Button>
                <div className="mx-1"/>
                <Button color="primary" className="mx-0" disabled={downloading} size="sm" onClick={() => handleDownload(item?.ID, item?.InvoiceNumber)}>{!downloading ? <i className="fa fa-download mr-1" /> : <i className="fa fa-spin fa-spinner mr-1" />}<Trans>{downloading ? "Downloading" : "Download PDF"}</Trans></Button>
            </>
            }
          </div>
          <LocalForm className="mt-3 inv-table"
            onSubmit={onSubmit}
            validators={{
              Name: { required },
              Date: { required },
              "LineItems[].Description": { required },
            }}
          >
            <Row>
              {/* <Col {...cStyle.common}>
                <FormGroup label="From">
                  <div {...cStyle.status}>
                    {item?.Contact?.FromName}
                  </div>
                </FormGroup>
              </Col> */}
              <Col {...cStyle.common}>
                <FormGroup label="To">
                  <div {...cStyle.status}>
                    {selectedOrganisation?.name}
                  </div>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Status">
                  <SpanColor>{getStatus(item.Status)}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Date" model=".Date">
                  <SpanColor>{formatedDate(item.Date) || "---"}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Due Date" model=".DueDate">
                  <SpanColor>{formatedDate(item.DueDate) || "---"}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Reference" model=".Reference">
                  <SpanColor>{item.Reference || '---'}</SpanColor>
                </FormGroup>
              </Col>
              <Col {...cStyle.common}>
                <FormGroup label="Invoice #" model=".InvoiceNumber">
                  <SpanColor>{item.InvoiceNumber}</SpanColor>
                </FormGroup>
              </Col>
            </Row>
            <hr />

       <div className="line-items" style={{marginBottom:'80px'}}>
        <Table className="table table-sm small line-items--table" responsive>
          <thead>
            <tr>
              <th
                className="text-nowrap text-left"
              >
                <Trans>Item/Description</Trans>
              </th>
              <th className="text-nowrap">
                <Trans>Qty</Trans>
              </th>
              <th className="text-nowrap">
                <Trans>Unit Price</Trans>
              </th>
                <th className="text-nowrap">
                  <Trans>Disc %</Trans>
                </th>
                <th className="text-nowrap">
                  <Trans>Tax</Trans>
                </th>
              <th className="text-nowrap text-right">
                <Trans>Amount</Trans>{" "}
                <CurrencySymbol currency={item.CurrencyCode} />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {item.LineItems.map((i, idx) => {
              const tracker = track(".LineItems[]", { _id: i._id });

              return (
                <Fieldset component="tr" model={tracker} key={i._id}>
                  <td className="td-color text-left">
                    {i.ItemCode ? (
                      <FormGroup style={{ fontSize: "1.3em" }}>
                        {i.ItemCode}
                      </FormGroup>
                    ) : null}
                    <FormGroup style={{width:400}}>
                      {i.Description}
                    </FormGroup>
                    <div className={`my-2 text-left}`} style={{ color: "#6F6F7B"}}>
                      {i.TaxType && (
                        <div>
                          Tax: <strong>{i.TaxType}</strong> 
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="td-color">
                    {i.Quantity || "-"}
                  </td>
                  <td className="td-color">
                    {i.UnitAmount || "-"}
                  </td>
                    <td className="td-color">
                      {i.DiscountRate || '-'}
                    </td>
                    <td className="td-color">
                      {i.TaxAmount || '-'}
                    </td>
                  <td className="td-color text-right">
                    {formatCurrency(i.LineAmount || "-")}
                  </td>
                </Fieldset>
              );
            })}
          </tbody>
        </Table>
        </div>
        <div className="d-flex align-items-end line-items-footer-responsive">
            <div className="mx-auto"/>
        <table className="mb-3" style={tableStyle}>
          <tbody className="text-right">
            <tr>
              <td style={tStyle}>
                <Trans>Subtotal</Trans>
                {Number(item.TotalDiscount) > 0 ? (
                  <>
                    {" "}
                    <span className="text-muted tw-text-sm">
                      <Trans>
                        (includes a discount of{" "}
                        {{ amount: formatCurrency(item.TotalDiscount) }})
                      </Trans>
                    </span>
                  </>
                ) : null}
              </td>
              <td style={tStyle}>{formatCurrency(item.SubTotal)}</td>
            </tr>
            {item.LineAmountTypes === "Inclusive" && (
              <tr>
                <td style={tStyle}>
                  <Trans>Includes Tax</Trans>
                </td>
                <td style={tStyle}>{formatCurrency(item.TotalTax)}</td>
              </tr>
            )}
            {item.LineAmountTypes === "Exclusive" && (
              <React.Fragment>
                <tr>
                  <td style={tStyle}>
                    <Trans>Total Tax</Trans>
                  </td>
                  <td style={tStyle}>{formatCurrency(item.TotalTax)}</td>
                </tr>
              </React.Fragment>
            )}
            <tr className="border-top border-bottom">
              <td className="h4 py-1" style={tStyle}>
                <Trans>Total</Trans>
              </td>
              <td className="h4" style={tStyle}>
                {formatCurrency(item.Total)}
              </td>
            </tr>
            {item?.Status === "PAID" && 
              <tr className="border-top border-bottom">
                <td style={tStyle}>
                <span style={{color:"#72B566"}}>
                    <Trans>Less Payment</Trans>
                </span>
                <br />
                {formatDate(item.FullyPaidOnDate)}
                </td>
                <td style={tStyle}>{formatCurrency(item.Total)}</td>
              </tr>
            }
            {item.AmountDue && (
              <tr className="border-top border-bottom">
                <td className="h4 py-1" style={tStyle}>
                  <Trans>Amount Due</Trans>
                </td>
                <td className="h4" style={tStyle}>{formatCurrency(item.AmountDue)}</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
          </LocalForm>
        </>
          :
          <><BackButton /><div className="text-center" style={{ fontSize: "1.3em" }}><p><Trans>The ID was not found, please make sure to check once and try again.</Trans></p></div></>
        }
      </Page>
    </div>
  );
};

const enhance = compose(
  withReload(),
  onMount(({ match, client }) => async () => {
    const { id } = match.params;
    const res = (await client.get(`/subscription-invoices/${id}`)).data
    const item = {
        "Type": "ACCREC",
        "ID": res?.id,
        "InvoiceID": res?.invoice_uid,
        "InvoiceNumber": res?.invoice_number,
        "SentToXero": false,
        "Contact": {
            "FromName": "Hesaab Riyada Company",
            "ToName": "",
        },
        "DateString": res?.issue_date,
        "Date": res?.issue_date,
        "DueDateString": res?.due_date,
        "DueDate": res?.due_date,
        "Status": res?.status.toUpperCase(),
        "LineAmountTypes": res?.line_amount_type,
        "LineItems": res?.invoice_line_items?.map((i) => ({
            "ItemCode": i.item_name,
            "Description": i.item_description,
            "UnitAmount": res?.line_amount_type === 'Inclusive' ? (parseFloat(i.unit_price) + parseFloat(i.vat_amount)).toFixed(2) : i.unit_price,
            "TaxType": res?.line_amount_type === 'NoTax' ? "No VAT" : "VAT (15%)",
            "TaxAmount": i.vat_amount,
            "LineAmount": i.line_amount,
            "AccountCode": "",
            "Item": {
              "ItemID": "",
              "Name": i.item_name,
              "Code": i.item_name,
            },
            "Tracking": [],
            "Quantity": i.quantity,
            "DiscountAmount": res?.discounted_amont,
            "AccountID": "",
        })),
        "SubTotal": res?.sub_total,
        "AmountDue": res?.status === "Unpaid" ? res?.total_amount : (res?.status === "Paid" ? "0.00"  : undefined),
        "TotalTax": res?.vat_amount,
        "Total": res?.total_amount,
        "UpdatedDateUTC": res?.updated_at,
        "CurrencyCode": res?.currency,
        "FullyPaidOnDate": res?.paid_at
    };

    return {
        item,
    };
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
);

export default enhance(ViewInvoice);
